import { CommonComponent } from "./common/common.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    component: CommonComponent,
    children: [
      // {
      //   path: "*",
      //   loadChildren: () =>
      //     import("src/app/intro/intro.module").then((m) => m.IntroModule),
      // },
      // {
      //   path: "",
      //   loadChildren: () =>
      //     import("src/app/intro/intro.module").then((m) => m.IntroModule),
      // },
      {
        path: "",
        loadChildren: () =>
          import("src/app/home/home.module").then((m) => m.HomeModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/fixtures/fixtures.module").then((m) => m.FixturesModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/news/news.module").then((m) => m.NewsModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/player/player.module").then((m) => m.PlayerModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/videos/videos.module").then((m) => m.VideosModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/membership/membership.module").then((m) => m.MembershipModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/login/login.module").then((m) => m.LoginModule),
      },
      {
				path: "notfound",
				loadChildren: () => import('src/app/notfound/notfound.module').then(m => m.NotfoundModule)
			},
      {
        path: "",
        loadChildren: () =>
          import("src/app/register/register.module").then((m) => m.RegisterModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/address/address.module").then((m) => m.AddressModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/livescore/livescore.module").then((m) => m.LivescoreModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/commercial/commercial.module").then((m) => m.CommercialModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/event/event.module").then((m) => m.EventModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/history/history.module").then((m) => m.HistoryModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/club/club.module").then((m) => m.ClubModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/community/community.module").then((m) => m.CommunityModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/shop/shop.module").then((m) => m.ShopModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/checkout/checkout.module").then((m) => m.CheckoutModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/confirmation/confirmation.module").then((m) => m.ConfirmationModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/outdoorevent/outdoorevent.module").then((m) => m.OutdooreventModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/tickets/tickets.module").then((m) => m.TicketsModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/buytickets/buytickets.module").then((m) => m.BuyticketsModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/academy/academy.module").then((m) => m.AcademyModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/privacy/privacy.module").then((m) => m.PrivacyModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/matchday/matchday.module").then((m) => m.MatchdayModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/vitalityblast/vitalityblast.module").then((m) => m.VitalityblastModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/zerotolerancepolicy/zerotolerancepolicy.module").then((m) => m.ZerotolerancepolicyModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/disclosingdiscrimination/disclosingdiscrimination.module").then((m) => m.DisclosingdiscriminationModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
